import React from 'react';
import { useHistory } from 'react-router-dom';
import MarketplaceOfferCard from 'partial/OfferManager/modules/MarketplaceOfferModule/MarketplaceOfferCard';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import MarketPlaceCarousel from 'partial/OfferManager/modules/MarketplaceOfferModule/MarketPlaceCarousel';
import { Row } from 'components/Containers/Row/Row';
import metadataMap from 'partial/OfferManager/modules/MarketplaceOfferModule/OfferCard.config.js';
import 'partial/OfferManager/modules/MarketplaceOfferModule/MarketplaceOfferModule.scss';
import { CLICK } from 'externals/_tracking/types/eventTypes.constants';
import { VERTICAL_OFFER_TYPE_MAP } from 'types/marketplaceTiles.constants';
import { MARKETPLACE_OFFER_CAROUSEL } from 'types/morph.pagePosition.constants';

const OfferSummary = props => {
  const history = useHistory();
  const { tiles, eventHandler } = props;

  return (
    <MarketPlaceCarousel
      type={'marketplaceCarouselRedesign'}
      customModuleName={MARKETPLACE_OFFER_CAROUSEL}
      modulePosition={props.modulePosition}
    >
      {tiles?.map((tile, index) => {
        const url = metadataMap[tile?.tileType]?.url;
        const offerVertical = VERTICAL_OFFER_TYPE_MAP[tile?.tileType];
        const linkEvent = () => {
          eventHandler(CLICK, {
            'Click Type': 'Tiles Click: ' + tile?.titleText,
            'Module Name': MARKETPLACE_OFFER_CAROUSEL,
            'Offer Module Position': index + 1,
            'Module Position': props?.modulePosition,
            Vertical: offerVertical,
          });
          history.push(url);
        };
        return (
          <MarketplaceOfferCard
            offerModulePosition={index + 1}
            modulePosition={props?.modulePosition}
            key={`${index}-${tile?.titleText}`}
            tileIconKey={tile?.icons.tileIcon}
            text={tile?.titleText}
            containerClasses="margR12 pointer"
            cardName={tile?.tileType}
            offerCardClass={'width125px height125px'}
            descriptionClass={'text-14'}
            onLinkClickEvent={linkEvent}
            verticalTracking={offerVertical}
            useImage
            url={url}
          />
        );
      })}
    </MarketPlaceCarousel>
  );
};

const ExploreOffersModuleView = props => {
  const { tiles, eventHandler, modulePosition } = props;
  return (
    <FlexContainer className="flex-column marketplace-offer-container">
      <FlexContainer className={'flex-column'}>
        <Row padL0>
          <FlexContainer className="flex-container m-items-align-center">
            <OfferSummary
              tiles={tiles}
              eventHandler={eventHandler}
              modulePosition={modulePosition}
            />
          </FlexContainer>
        </Row>
      </FlexContainer>
    </FlexContainer>
  );
};

export default ExploreOffersModuleView;
